export default __webpack_public_path__ + "static/media/cpanel.dc637b4e.svg";